

























































































































































import { Component } from 'vue-property-decorator';
import BreadcrumbComponent from '@/_shared/components/layout/breadcrumb.component.vue';
import RankService from '@/_shared/services/rank.service';
import Rep from '@/_shared/entities/rep/rep.entity';
import AuthService from '@/_shared/services/auth/auth.service';
import moment from 'moment';
import RankProgress, { VolumeInterface } from '@/earn/entities/rank-progress.entity';
import RankComparison from '@/earn/entities/rank-comparison/rank-comparison.entity';
import MilestoneStatus from '@/earn/components/milestone-status.component.vue';
import MilestoneStatusInterface from '@/earn/interfaces/milestone-status.interface';
import Rank from '@/_shared/entities/rank/rank.entity';
import AverageIncomeButton from '@/earn/components/rank-comparison/average-income-button.component.vue';
import UserMilestoneStatus from '@/earn/components/user-milestone-status.component.vue';
import RepHeader from '@/_shared/entities/rep/rep-header.entity';
import MilestoneDate from '@/earn/interfaces/milestone-date.interface';
import NoResults from '@/_shared/components/globals/no-results.component.vue';
import SearchComponent from '@/_shared/components/search/search.component.vue';
import InfoIcon from '@/_shared/components/icons/info-icon.component.vue';
import ThemeService from '@/_shared/services/theme.service';
import OrganizationService from '@/manage/services/organization.service';
import IdentifierInterface from '@/_shared/interfaces/identifier.entity';
import Option from '@/_shared/interfaces/filter/option.interface';
import isDate from 'lodash/isDate';
import RankBar from '@/_shared/components/globals/rank-bar.component.vue';
import ranks from '@/_shared/constants/ranks';
import omitBy from 'lodash/omitBy';
import RankReportMixin from '@/earn/mixins/rank-report.mixin';
import BackToReportButton from '@/_shared/components/globals/back-to-report-button.component.vue';

@Component({
  components: {
    InfoIcon,
    RankBar,
    SearchComponent,
    NoResults,
    UserMilestoneStatus,
    AverageIncomeButton,
    MilestoneStatus,
    BreadcrumbComponent,
    BackToReportButton,
  },
})
export default class RankComparisonView extends RankReportMixin {
  finishedLoading = false;
  rankProgress: RankProgress | null = null;
  userHeader: RepHeader = new RepHeader();
  selectedDate: MilestoneDate = {
    current: moment(this.currentDate).utc().format('YYYY-MM-DD'),
    next: '',
    previous: '',
  };
  selectedRank: Rank | null = null;
  currentRank: Rank | null = null;
  themeService = ThemeService;
  placementDistributors: Option[] = [];
  searchString = '';
  selectedRepDid: string | null = null;
  loadingResults = false;

  get rep(): Rep {
    return this.$store.state.RepStore.rep;
  }

  get loggedUserDid(): string {
    return this.rep.did.toString();
  }

  get activeRepDid(): string {
    return this.selectedRepDid || this.loggedUserDid;
  }

  get showBuildDate(): boolean {
    return !!this.rankProgress && !!this.buildDate;
  }

  get buildDate(): string {
    const datetime: Date | undefined = this.rankProgress?.datetime;
    if (!datetime || !isDate(datetime)) return '';
    return `${datetime.toLocaleDateString()}, ${datetime.toLocaleTimeString()}`;
  }

  get currentDate(): string {
    const dayOfTheMonth = Number(moment().format('D'));
    const hourOfTheDay = Number(moment().format('H'));
    if (dayOfTheMonth === 1 && hourOfTheDay < 12) {
      return moment().subtract(1, 'day').format('YYYY-MM-DD');
    }
    return moment().format('YYYY-MM-DD');
  }

  get lifetimeRank(): Rank | undefined {
    const ranksWithAdvancementDate = this.allRanks.filter((rank) => !!rank.achievementDate);
    return ranksWithAdvancementDate.pop();
  }

  get isSelectedRankLifetimeRank(): boolean {
    return !!this.lifetimeRank && this.nextRank?.id === this.lifetimeRank.id;
  }

  get currentRankVolumes(): RankComparison | undefined {
    const currentRankId = this.currentRank?.id;
    if (!currentRankId) return undefined;
    return this.rankComparison?.find((rank: RankComparison) => rank.rankId === currentRankId);
  }

  get currentRankItems(): MilestoneStatusInterface[] {
    return [
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_QUALIFYING_VOLUME').toString(),
        value: this.currentRankVolumes?.rankPv || 0,
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_GROUP_VOLUME').toString(),
        value: this.currentRankVolumes?.rankGv || 0,
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_VOLUME_OUTSIDE_LARGEST_LEG').toString(),
        value: this.currentRankVolumes?.rankVolumeOutsideLargestLeg || 0,
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_VOLUME_OUTSIDE_LARGEST_TWO_LEG').toString(),
        value: this.currentRankVolumes?.rankVolumeOutsideLargestTwoLegs || 0,
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_TOTAL_LEGS').toString(),
        value: this.currentRankVolumes?.legs || 0,
      },
    ];
  }

  get userVolumes(): MilestoneStatusInterface[] {
    const volumes: VolumeInterface | undefined = this.rankProgress?.volumes.total;
    return [
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_QUALIFYING_VOLUME').toString(),
        value: volumes?.currentPaidAsRankQv || 0,
        needToReach: this.calculateDifference(
          volumes?.currentPaidAsRankQv,
          this.nextRankVolumes?.rankPv,
        ),
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_GROUP_VOLUME').toString(),
        value: volumes?.currentPaidAsRankGv || 0,
        needToReach: this.calculateDifference(
          volumes?.currentPaidAsRankGv,
          this.nextRankVolumes?.rankGv,
        ),
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_VOLUME_OUTSIDE_LARGEST_LEG').toString(),
        value: volumes?.currentPaidAsRankVolumeOutsideLargestLeg || 0,
        needToReach: this.calculateDifference(
          volumes?.currentPaidAsRankVolumeOutsideLargestLeg,
          this.nextRankVolumes?.rankVolumeOutsideLargestLeg,
        ),
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_VOLUME_OUTSIDE_LARGEST_TWO_LEG').toString(),
        value: volumes?.currentPaidAsRankVolumeOutsideLargestTwoLeg || 0,
        needToReach: this.calculateDifference(
          volumes?.currentPaidAsRankVolumeOutsideLargestTwoLeg,
          this.nextRankVolumes?.rankVolumeOutsideLargestTwoLegs,
        ),
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_TOTAL_LEGS').toString(),
        value: this.rankProgress?.legsWithMoreThan100QV || 0,
        needToReach: this.calculateDifference(
          this.rankProgress?.legsWithMoreThan100QV,
          this.nextRankVolumes?.legs,
        ),
      },
    ];
  }

  get nextRankVolumes(): RankComparison | undefined {
    const currentRankId = this.rankProgress?.ranks?.next?.id;
    if (!currentRankId) return undefined;
    return this.rankComparison?.find((rank: RankComparison) => rank.rankId === currentRankId);
  }

  get nextRank(): Rank | undefined {
    return this.rankProgress?.ranks?.next;
  }

  get nextRankItems(): MilestoneStatusInterface[] {
    return [
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_QUALIFYING_VOLUME').toString(),
        value: this.nextRankVolumes?.rankPv || 0,
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_GROUP_VOLUME').toString(),
        value: this.nextRankVolumes?.rankGv || 0,
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_VOLUME_OUTSIDE_LARGEST_LEG').toString(),
        value: this.nextRankVolumes?.rankVolumeOutsideLargestLeg || 0,
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_VOLUME_OUTSIDE_LARGEST_TWO_LEG').toString(),
        value: this.nextRankVolumes?.rankVolumeOutsideLargestTwoLegs || 0,
      },
      {
        label: this.$t('RANK_COMPARISON_REPORT.INFO_RANK_TOTAL_LEGS').toString(),
        value: this.nextRankVolumes?.legs || 0,
      },
    ];
  }

  get showNextButton(): boolean {
    if (!this.selectedDate) return false;
    const currentDate = moment(this.currentDate);
    const selectedDate = moment(this.selectedDate.current);
    const isSelectedDateCurrentDate = currentDate.month() === selectedDate.month()
      && currentDate.year() === selectedDate.year();
    return !!this.selectedDate.next && !isSelectedDateCurrentDate;
  }

  backToMyReport(): void {
    this.applySearchString(this.loggedUserDid);
    this.searchString = '';
  }

  handleChangeRank(): void {
    this.$store.dispatch('showLoading');
    this.getRankProgress(this.activeRepDid, this.selectedDate.current, false)
      .finally(() => {
        this.$store.dispatch('hideLoading');
      });
  }

  goToRankLegStatus(): void {
    const isSameUserReport = this.loggedUserDid === this.activeRepDid;
    const params: Record<string, any> = omitBy({
      month: this.selectedDate.current,
      rankId: this.selectedRank?.id,
      repDid: isSameUserReport ? null : this.hashIds.encode(this.activeRepDid),
    }, (value) => !value);
    const { href } = this.$router.resolve({ name: 'rank-leg-status', query: params });
    window.open(href, '_blank');
  }

  calculateDifference(current = 0, next = 0): number {
    const difference = next - current;
    return difference < 0 ? 0 : difference;
  }

  handleChangeMonth(date: string): void {
    this.$store.dispatch('showLoading');
    this.getRankProgress(this.activeRepDid, date)
      .finally(() => {
        this.$store.dispatch('hideLoading');
      });
  }

  retrieveData(): void {
    this.$store.dispatch('showLoading');
    this.finishedLoading = false;
    Promise.all([
      this.getInfoByUser(this.activeRepDid, true),
    ]).then(() => this.retrieveRankFromQuery(this.activeRepDid))
      .finally(() => {
        this.$store.dispatch('hideLoading');
        this.finishedLoading = true;
      });
  }

  async applySearchString(repDid: string): Promise<void> {
    this.selectedRank = null;
    this.selectedRepDid = repDid;
    this.$store.dispatch('showLoading');
    try {
      await this.getInfoByUser(repDid, true, this.currentDate);
    } finally {
      this.$store.dispatch('hideLoading');
    }
  }

  getInfoByUser(
    repDid: string,
    saveCurrentRank: boolean,
    currentDate = this.selectedDate.current,
  ): Promise<void> {
    return Promise.all([
      this.getRankAchievements(repDid),
      this.getRankProgress(repDid, currentDate, saveCurrentRank),
      this.getRankComparison(repDid),
    ]).then(() => this.retrieveRepHeader(repDid));
  }

  retrieveRankFromQuery(repDid: string): Promise<void> {
    const queryRankId = Number(this.$route.query.rankId);
    const queryRankConstant = ranks.find((rank) => rank.id === Number(this.$route.query.rankId));
    if (queryRankId && queryRankConstant) {
      this.selectedRank = queryRankConstant;
      return this.getRankProgress(repDid, this.selectedDate.current);
    }
    return Promise.resolve();
  }

  retrieveRepHeader(repDid: string): Promise<void> {
    const fallbackPicture = this.rankProgress?.distributorPicture || 'https://assets.kyani.net/uploads/50/IBzPT.200727.200.jpg';
    return AuthService.getRepHeader(repDid)
      .then((response) => {
        this.userHeader.picture = response.picture || fallbackPicture;
        this.userHeader.name = response.name || '';
      })
      .catch(() => {
        this.userHeader.picture = fallbackPicture;
        this.userHeader.name = '';
      });
  }

  getRankProgress(repDid: string, currentDate: string, saveCurrentRank = false): Promise<void> {
    const rankId = this.selectedRank ? this.selectedRank.id : undefined;
    return RankService.getBpRankProgress(repDid, currentDate, rankId)
      .then((response) => {
        this.rankProgress = response;
        this.updateRankProgressInfo(saveCurrentRank, currentDate);
      })
      .catch(() => {
        this.rankProgress = null;
      });
  }

  private updateRankProgressInfo(saveCurrentRank: boolean, currentDate: string) {
    if (!this.rankProgress) return;
    this.selectedRank = this.rankProgress.ranks.next;
    if (saveCurrentRank) {
      this.currentRank = this.rankProgress.ranks.current;
    }
    this.setSelectedDate(currentDate);
  }

  setSelectedDate(currentDate: string): void {
    if (!this.rankProgress) return;
    const { last, next } = this.rankProgress.links;
    this.selectedDate.current = currentDate ? moment(currentDate).utc().format('YYYY-MM-DD') : '';
    this.selectedDate.previous = last ? moment(last).utc().format('YYYY-MM-DD') : '';
    this.selectedDate.next = next ? moment(next).utc().format('YYYY-MM-DD') : '';
  }

  retrievePlacement(searchString: string): void {
    if (!searchString) {
      this.placementDistributors = [];
      return;
    }
    this.loadingResults = true;
    OrganizationService.getGenealogyDistributors(this.loggedUserDid, {
      value: searchString,
      hideCancelled: false,
      hideZeroGQV: false,
    }).then((response) => {
      this.placementDistributors = this.mapPlacementDistributors(response);
    }).catch(() => {
      this.placementDistributors = [];
    }).finally(() => {
      this.loadingResults = false;
    });
  }

  mapPlacementDistributors(response: IdentifierInterface[]): Option[] {
    return (response || []).map((item: IdentifierInterface) => ({
      label: `<strong style="font-weight: 600">${item.name}</strong> - ${item.id}`,
      value: item.id.toString(),
    }));
  }

  setSelectedRep() {
    const queryRepDid = this.$route.query.repDid?.toString();
    this.selectedRepDid = this.hashIds.decode(queryRepDid).toString() || this.loggedUserDid;
  }

  created() {
    this.setSelectedRep();
    this.retrieveData();
  }
}
